import { client } from "../client";
import type { Earmold, Variant } from "../types/earmold.types";
import { createFile } from "./file.mutations";

const getUploadableFile = (file: unknown): File | null => {
	if (!(file instanceof File)) {
		return null;
	}
	return file;
};

export const createEarmold = async (earmold: Partial<Earmold>) => {
	// 1. Upload file
	let file = null;
	const fileToUpload = getUploadableFile(earmold.file);
	if (fileToUpload) {
		file = await createFile({
			file: fileToUpload,
			fileName: undefined,
		});
	}
	// 2. Create earmold
	const response = await client.post<Earmold>(`earmolds/`, {
		...earmold,
		fileId: file ? file.id : null,
	});
	return response.data;
};

export const updateEarmold = async ({
	id,
	earmold,
}: {
	id: number | string | undefined;
	earmold: Partial<Earmold>;
}) => {
	if (id === undefined) {
		return null;
	}
	// 1. Upload file
	let file = null;
	const fileToUpload = getUploadableFile(earmold.file);
	if (fileToUpload) {
		file = await createFile({
			file: fileToUpload,
			fileName: undefined,
		});
	}
	const response = await client.patch<Earmold>(`earmolds/${id}`, {
		...earmold,
		fileId: file ? file.id : undefined,
	});
	return response.data;
};

export const createEarmoldVariants = async ({
	id,
	variant,
}: {
	id: number | string | undefined;
	variant: Partial<Variant>;
}) => {
	if (id === undefined) {
		return null;
	}
	const response = await client.post<Earmold>(
		`earmolds/${id}/variants`,
		variant,
	);
	return response.data;
};
